import {useNavigate, useLocation} from 'react-router-dom';


export class SearchParamsKey {
  static readonly email = 'email'
  static readonly code = 'code'
  static readonly chat = 'chat'
  static readonly userId = 'userId'
  static readonly userName = 'userName'
  static readonly users = 'users'
}

export const useUrlParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const setUrlParam = (key: string, value: string | null) => {
    const params = new URLSearchParams(location.search);

    if (value === null) {
      params.delete(key);
    } else {
      params.set(key, value);
    }

    navigate({search: params.toString()}, {replace: true});
  };

  const getUrlParam = (key: string): string | undefined => {
    const params = new URLSearchParams(location.search);
    return params.get(key) ?? undefined;
  };

  const deleteUrlParam = (key: string) => {
    const params = new URLSearchParams(location.search);
    params.delete(key);
    navigate({search: params.toString()}, {replace: true});
  };



  return {setUrlParam, getUrlParam, deleteUrlParam};
};